import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './RecurringEndDatePicker.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The end date picker for recurring frequencies.
 */
export const RecurringEndDatePicker = ({
  onChange,
  onBlur,
  shouldShowErrorState = false,
  recurringEndDate,
  ...rest
}) => {
  const {
    t
  } = useTranslation('blocks.impact');
  return /*#__PURE__*/_jsxs(Styled.Label, {
    htmlFor: "end-date",
    children: [/*#__PURE__*/_jsx("span", {
      children: t('RecurringEndDatePicker.endDate.label', 'End date (optional)')
    }), /*#__PURE__*/_jsx(Styled.EndDatePicker, {
      shouldShowErrorState: shouldShowErrorState,
      "data-id": "cp-impact-recurring-end-date",
      id: "end-date",
      disablePastDates: true,
      onChangeCallback: onChange,
      onBlur: onBlur,
      value: recurringEndDate,
      ...rest
    })]
  });
};